var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel t1 text-center p-2"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t("Gesamtsumme"))+": "+_vm._s(_vm._f("currency")(_vm.total,_vm.cSymb)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }